import { render, staticRenderFns } from "./ClosureEditor.vue?vue&type=template&id=0f3c97cc&"
import script from "./ClosureEditor.vue?vue&type=script&lang=js&"
export * from "./ClosureEditor.vue?vue&type=script&lang=js&"
import style0 from "./ClosureEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports